import './WorkspacePlaceholder/styles.css';

export function WorkspacePlaceholder({ wide = false }) {
  const classes = ['workspacePlaceholder', wide ? 'workspacePlaceholderWide' : ''].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <div className="workspacePlaceholderFrame">
        <header className="workspaceHeader">
          <div className="workspaceLogo">SW</div>
          <div className="workspaceHeaderCopy">
            <p className="workspaceTitle">Smart Waste Project</p>
            <p className="workspaceMeta">4 Members • Active</p>
          </div>
        </header>

        <div className="workspaceMain">
          <aside className="workspaceSidebar">
            <p className="workspaceSidebarLabel">CHANNELS</p>
            <ul className="workspaceChannels">
              <li className="workspaceChannel workspaceChannelActive"># general</li>
              <li className="workspaceChannel"># design</li>
              <li className="workspaceChannel"># development</li>
            </ul>
          </aside>

          <section className="workspaceChat">
            <div className="workspaceBubble workspaceBubbleLeft">
              <span className="workspaceAvatar" />
              <p>I've uploaded the new CAD models.</p>
            </div>
            <div className="workspaceBubble workspaceBubbleRight">
              <p>Looks great! I'll start the simulation.</p>
              <span className="workspaceAvatar workspaceAvatarRight" />
            </div>
            <div className="workspaceInput">Message #general...</div>
          </section>
        </div>
      </div>
    </div>
  );
}
